import useMediaQuery from "@mui/material/useMediaQuery";
import { useAuth } from "../../contexts/AuthContext";
import {
  BannerRoot,
  BannerLeft,
  BannerTrialPill,
  BannerMessage,
  BannerDaysRemaining,
} from "./style.js";

const FreeTrialBanner = () => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const { loggedInUser } = useAuth();

  const user = loggedInUser as { is_trial?: boolean; date_joined?: string; first_name?: string } | undefined;
  if (!user?.is_trial || !user?.date_joined) return null;

  const trialExpiry = new Date(user.date_joined).getTime() + 10 * 24 * 60 * 60 * 1000;
  const daysRemaining = Math.max(0, Math.ceil((trialExpiry - Date.now()) / (1000 * 60 * 60 * 24)));

  const text = isMobile
    ? ""
    : `Welcome, ${loggedInUser?.first_name || "there"}! Your free trial is active.`;

  return (
    <BannerRoot>
      <BannerLeft>
        <BannerTrialPill>⚡ Free Trial</BannerTrialPill>
        <BannerMessage>{text}</BannerMessage>
      </BannerLeft>
      <BannerDaysRemaining>
        {daysRemaining} day{daysRemaining !== 1 ? "s" : ""} remaining
      </BannerDaysRemaining>
    </BannerRoot>
  );
};

export default FreeTrialBanner;
